export const GET_ALLOYWHEELS_STATED = "GET_ALLOYWHEELS_STATED";
export const GET_ALLOYWHEELS = "GET_ALLOYWHEELS";
export const GET_ALLOYWHEELS_ENDED = "GET_ALLOYWHEELS_ENDED";
export const ADD_ALLOYWHEEL_STATED = "ADD_ALLOYWHEEL_STARTED";
export const ADD_ALLOYWHEEL = "ADD_ALLOYWHEEL";
export const ADD_ALLOYWHEEL_ENDED = "ADD_ALLOYWHEEL_ENDED";
export const EDIT_ALLOYWHEEL_STATED = "EDIT_ALLOYWHEEL_STATED";
export const EDIT_ALLOYWHEEL = "EDIT_ALLOYWHEEL";
export const EDIT_ALLOYWHEEL_ENDED = "EDIT_ALLOYWHEEL_ENDED";
export const GET_ALLOYWHEEL = "GET_ALLOYWHEEL";
export const GET_ALLOYWHEEL_STATED = "GET_ALLOYWHEEL_STATED";
export const GET_ALLOYWHEEL_ENDED = "GET_ALLOYWHEEL_ENDED";
export const RESET_ALLOYWHEEL = "RESET_ALLOYWHEEL";
export const ERROR_ALLOYWHEEL = "ERROR_ALLOYWHEEL";
export const GET_ALL_ALLOYWHEELS_STATED = "GET_ALL_ALLOYWHEELS_STATED";
export const GET_ALL_ALLOYWHEELS = "GET_ALL_ALLOYWHEELS";
export const GET_ALL_ALLOYWHEELS_ENDED = "GET_ALL_ALLOYWHEELS_ENDED";
